<template>
  <router-view/>
  <div class="space" style="height:200px;"></div>
</template>

<style>
	/* css reset */

	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed, 
	figure, figcaption, footer, header, hgroup, 
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure, 
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	body {
		line-height: 1;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
	a{all: unset;cursor: pointer;}
	/* css rest end  */

</style>

<style>
	@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
	@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
	body{
		--primary-saf-color: #FF5614;
		--nav-blue: #3498DB;
		--black: #000000;

		max-width: 100%;
		overflow-x: hidden;
	}

	.container{
		/* font-family: 'Open Sans', sans-serif; */
		max-width: 1500px;
		display: block;
		/* overflow-x: hidden; */
		margin: 0 auto;;
	}

	img{
		object-fit: contain;
	}
</style>